"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _AccessTime = _interopRequireDefault(require("@material-ui/icons/AccessTime"));
var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));
var _Switch = _interopRequireDefault(require("../Switch"));
var _excluded = ["checked", "onClick", "invert"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var View = function View(_ref) {
  var checked = _ref.checked,
    _onClick = _ref.onClick,
    _ref$invert = _ref.invert,
    invert = _ref$invert === void 0 ? false : _ref$invert,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var endAt = (0, _react.useMemo)(function () {
    var currTimezone = _momentTimezone["default"].tz.guess();
    var endAt = props.endAt,
      timezone = props.timezone;
    return [endAt ? _momentTimezone["default"].unix(endAt).format('h:mma') : null, timezone && timezone !== currTimezone ? _momentTimezone["default"].tz(timezone).format('z') : null].filter(Boolean).join(' ');
  }, [props.endAt, props.timezone]);
  return /*#__PURE__*/_react["default"].createElement(_Slide["default"], {
    unmountOnExit: true,
    direction: "down",
    "in": checked
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-24 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('min-w-70vw md:min-w-50vw lg:min-w-30vw flex items-center justify-between', 'rounded-full text-sm font-light bg-app dark:bg-card my-auto px-4 py-2', {
      'shadow-lg dark:shadow-deep': !invert
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 pl-8"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-light"
  }, /*#__PURE__*/_react["default"].createElement(_AccessTime["default"], null)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "px-4"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: !!endAt ? 'inboxBreak.banner.withEndTime' : 'inboxBreak.banner.withoutEndTime',
    values: {
      endAt: endAt
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  })))), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    size: "sm",
    checked: checked,
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      _onClick(e.target.checked);
    }
  }))));
};
View.displayName = 'InboxBreakBanner';
var _default = exports["default"] = View;
//# sourceMappingURL=Banner.js.map